<header class="header__container">
    <div class="header">
        <div class="header__logo">
            <img [src]="logoUrl" alt="KioskPolis" class="header__logo--img">
        </div>

        <div class="header__text">
            <h2 class="header__title">
                {{ 'header' | translate }}
            </h2>
        </div>
    </div>
</header>

<div class="container container--center text-center">
    <div class="container__title">
        <h2>{{ 'error' | translate }}</h2>
        <img [src]="informationImage">
    </div>
    <div class="container__content">
        <p class="big-text">{{ 'connectionErrorMessage' | translate }}</p>
    </div>
    <div class="button__container">
        <button class="btn btn--secondary btn--big btn--no-outline"
                id="prev-desktop-button"
                [ngClass]="{'btn--anchor': anchorButton}"
                (click)="refreshApp()">
            <ng-container *ngIf="!anchorButton; else anchorBtn">
                {{ 'refreshApp' | translate }}
            </ng-container>
            <ng-template #anchorBtn>
                <a [href]="redirectUrl | safeUrl" target="_blank">
                    {{ 'refreshApp' | translate }}
                </a>
            </ng-template>
        </button>
    </div>
</div>
